import { GlossaryItem } from '@features/glossary';
import {
  TextProps,
  TextPropsTextConfig,
  blankLine,
} from '@features/powerpoint';
import { definitionText } from '../components/definition-text';

export const getDefinitions = (
  glossaryEntries: GlossaryItem[],
  column: number,
  runningTotal: number[]
): TextProps => {
  return {
    text: glossaryEntries
      .slice(runningTotal[column - 1] ?? 0, runningTotal[column])
      .flatMap(({ label, definition, subItems }): TextPropsTextConfig[] => [
        ...definitionText(label, definition),
        ...(subItems
          ? Object.values(subItems).flatMap((subItem): TextPropsTextConfig[] =>
              definitionText(subItem.label, subItem.definition, {
                subItem: true,
              })
            )
          : []),
        blankLine,
      ]),
  };
};
